<template>
    <div>
        <v-dialog v-model="open" persistent max-width="600" scrollable>
            <v-card>
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title v-if="user">Editar usuario</v-toolbar-title>
                    <v-toolbar-title v-else>Añadir usuario</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text style="max-height: 600px;">
                    <v-form ref="form" class="text-center">
                        <v-card flat>
                            <v-card-text>
                                <v-row class="py-6">
                                    <v-col cols="12" class="px-6">
                                        <v-text-field
                                            v-model="local_user.email"
                                            label="Correo"
                                            solo
                                            dense
                                            outlined
                                            flat
                                            hide-details
                                            prepend-inner-icon="mdi-email"
                                            :disabled="user != null"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" class="py-0 px-6" v-if="!user">
                                        <v-text-field
                                            v-model="local_user.password"
                                            :type="show_password.field1 ? 'text' : 'password'"
                                            label="Password"
                                            solo
                                            dense
                                            outlined
                                            flat
                                            hide-details
                                            @click:append="show_password.field1 = !show_password.field1"
                                            :append-icon="!show_password.field1 ? 'mdi-eye' : 'mdi-eye-off'"
                                            prepend-inner-icon="mdi-key"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" class=" px-6" v-if="!user">
                                        <v-text-field
                                            v-model="local_user.confirm_password"
                                            :type="show_password.field2 ? 'text' : 'password'"
                                            label="Confirmar Password"
                                            solo
                                            dense
                                            outlined
                                            flat
                                            hide-details
                                            @click:append="show_password.field2 = !show_password.field2"
                                            :append-icon="!show_password.field2 ? 'mdi-eye' : 'mdi-eye-off'"
                                            prepend-inner-icon="mdi-key"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" class="px-6 py-3" v-if="!user">
                                        <v-divider></v-divider>
                                    </v-col>
                                    <v-col cols="12" class="px-6">
                                        <v-select
                                            v-model="local_user.level"
                                            solo
                                            dense
                                            outlined
                                            flat
                                            :items="[{
                                                text: 'Administrador',
                                                value: LEVEL_ADMIN
                                            },{
                                                text: 'Usuario',
                                                value: LEVEL_USER
                                            }]"
                                            label="Tipo de usuario"
                                            hide-details
                                            prepend-inner-icon="mdi-account-circle"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" class="px-6 py-3" v-if="user">
                                        <v-divider></v-divider>
                                    </v-col>
                                    <v-col cols="12" v-if="user && local_user.level != LEVEL_ADMIN">
                                        <listPlants ref="list_plants" :user="user.id" />
                                    </v-col>
                                    <v-col v-if="error != ''" class="pa-0 red--text">
                                        {{ error }}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-btn 
                                            v-if="user"
                                            :loading="loading"
                                            block 
                                            color="accent"
                                            @click="saveEditUser"
                                            > Guardar </v-btn>
                                        <v-btn 
                                            v-else
                                            :disabled="
                                                local_user.email == '' || 
                                                local_user.level == '' ||
                                                local_user.password == ''"
                                            :loading="loading"
                                            color="accent" 
                                            block
                                            @click="saveNewUser"
                                            >Guardar</v-btn>

                                    </v-col>
                                    <v-col cols="12">
                                        <v-btn
                                            color="blue-grey"
                                            text
                                            block
                                            @click="close"
                                            >Cancelar</v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { LEVEL_USER, LEVEL_ADMIN } from '../../../plugins/checkPermission'
import { mapActions, mapGetters } from 'vuex'
import listPlants from './list_plants'

export default {
    name: 'new_user',
    props: ['open', 'user'],
    components: { listPlants },
    data() {
        return {
            LEVEL_USER, LEVEL_ADMIN,
            local_user: {
                email: '',
                password: '',
                confirm_password: '',
                level: ''
            },
            show_password: {
                field1: false,
                field2: false
            },
            loading: false,
            error: ''
        }
    },
    methods: {
        ...mapActions({ 
            addUser: 'account/addUser',
            getPlants: 'account/getPlantsUsers',
            editUserLevel: 'account/editUserLevel'
        }),
        async saveNewUser(){
            try {
                if(this.local_user.password != this.local_user.confirm_password){
                    this.error = 'Las contraseñas no coinciden'
                    setTimeout(this.hideError, 3000)
                    return
                }
                this.loading = true
                await this.addUser({
                    email: this.local_user.email,
                    level: this.local_user.level,
                    password: this.local_user.password
                })
                this.loading = false
                this.close()
            } catch (error) {
                this.loading = false
                if(error.message){
                    this.error = error.message
                    setTimeout(this.hideError, 3000)
                } 
            }
        },
        async saveEditUser(){
            try {
                this.loading = true
                if(this.local_user.level != LEVEL_ADMIN)
                    this.$refs.list_plants.save(this.user.id)
                await this.editUserLevel({ 
                    user: this.user.id,
                    level: this.local_user.level
                })
                this.loading = false
                this.close()
            } catch (error) {
                console.log(error)
                this.loading = false
                if(error.message)
                    this.error = error.message
            }
        },
        hideError(){
            this.error = null
        },
        close(){
            this.local_user = {
                email: '',
                password: '', 
                level: '' 
            }
            this.$emit('close')
        }
    },
    watch: {
        user(){
            if(this.user){
                this.local_user.email = this.user.email
                this.local_user.level = this.user.level
            }
        }
    },
}
</script>